import { faUser } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  UncontrolledDropdown,
} from 'reactstrap';
import { Dispatch } from 'redux';
import { UserRole } from 'stageclip-common';

import { createLogoutAction } from '../../actions/logoutActions';
import { createModalOpenAction } from '../../actions/modalActions';
import StageClipLogo from '../../assets/images/stage-clip-logo.png';
import { SimpleModalId } from '../../constants/modalId';
import * as PermissionsHelper from '../../helpers/permissionsHelper';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';
import AppModal from '../modal/appModal';
import { AegisubAudioToVideoConverter } from '../tools/aegisubAudioToVideoConverter';
import { FullName } from '../users/fullName';
import Icon from '../utils/icon';

import styles from './topMenu.module.scss';

interface TopMenuDispatchProps extends BaseDispatchProps {
  logout: () => void;
  openAegisubAudioVideoTool: () => void;
}

class TopMenu extends ComponentBase<{}, BaseStateProps, TopMenuDispatchProps> {
  protected loggedInRender() {
    return this.renderTopMenu(this.navigationMenu());
  }

  protected loggedOutRender() {
    return this.renderTopMenu();
  }

  // noinspection JSMethodCanBeStatic
  private renderTopMenu(barComponent?: any) {
    return (
      <div className={styles.topMenu}>
        <Navbar>
          <NavbarBrand tag={Link} to="/" className={styles.brandLogo}>
            <img src={StageClipLogo} alt="Stage Clip" />
          </NavbarBrand>
          <div className={styles.title}>Clipping Platform</div>
          {barComponent}
        </Navbar>
      </div>
    );
  }

  private navigationMenu() {
    return (
      <>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessAegisubAudioToVideoConverter) && (
          <AppModal id={SimpleModalId.AegisubAudioToVideoTranslator} title="Aegisub Audio->Video" hideOpenButton>
            <AegisubAudioToVideoConverter />
          </AppModal>
        )}
        <Nav className={styles.menuWrapper}>
          <NavItem>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessClipGenerator) && (
              <NavLink tag={Link} to="/clip-generator">
                Clip Generator
              </NavLink>
            )}
          </NavItem>
          <NavItem>
            <NavLink tag={Link} to="/events">
              Events
            </NavLink>
          </NavItem>
          <NavItem>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GetMoEvents) && (
              <NavLink tag={Link} to="/mo-events">
                MO Events
              </NavLink>
            )}
          </NavItem>
          <NavItem>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessClientsPage) && (
              <NavLink tag={Link} to="/clients">
                Clients
              </NavLink>
            )}
          </NavItem>
          <NavItem>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessShops) && (
              <NavLink tag={Link} to="/shops">
                Shops
              </NavLink>
            )}
          </NavItem>
          <NavItem>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessPortals) && (
              <NavLink tag={Link} to="/clip-sites">
                Clip Sites
              </NavLink>
            )}
          </NavItem>
          <UncontrolledDropdown>
            <DropdownToggle nav caret>
              Tools
            </DropdownToggle>
            <DropdownMenu right>
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessAegisubAudioToVideoConverter) && (
                // eslint-disable-next-line react/no-unescaped-entities
                <DropdownItem onClick={this.openAegisubAudioVideoTool}>Aegisub Audio-&gt;Video</DropdownItem>
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.MonitoringPage) && (
                <DropdownItem tag={Link} to="/monitoring">
                  Monitoring
                </DropdownItem>
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.MonitoringVGPage) && (
                <DropdownItem tag={Link} to="/monitoring-vg">
                  Virtual Graduation Monitoring
                </DropdownItem>
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.VgQaQueue) && (
                <DropdownItem tag={Link} to="/qa-queue">
                  Virtual Graduation QA queue
                </DropdownItem>
              )}
              <DropdownItem tag={Link} to="/events-clipping-queue">
                Clipping Queue
              </DropdownItem>
              <DropdownItem tag={Link} to="/events-qa-queue">
                QA Queue
              </DropdownItem>
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessAdminSection) && (
                <DropdownItem tag={Link} to="/participant-search">
                  Participant search
                </DropdownItem>
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ViewMailerLog) && (
                <DropdownItem tag={Link} to="/mailer-log">
                  Mailer log
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessAdminSection) && (
            <UncontrolledDropdown>
              <DropdownToggle nav caret>
                Admin
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem tag={Link} to="/users">
                  Users
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )}
          {this.props.currentUser.role === UserRole.Admin && (
            <NavItem>
              <NavLink tag={Link} to="/notifications">
                Notifications
              </NavLink>
            </NavItem>
          )}
          <UncontrolledDropdown className={styles.userMenu}>
            <DropdownToggle nav caret className={styles.userName}>
              <Icon icon={faUser} />
              <FullName user={this.props.currentUser} />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem tag={Link} to="/users/change-my-password">
                Change Password
              </DropdownItem>
              <DropdownItem onClick={this.props.logout}>Logout</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </>
    );
  }

  private openAegisubAudioVideoTool = () => {
    this.props.openAegisubAudioVideoTool();
  };
}

function mapDispatchToProps(dispatch: Dispatch): TopMenuDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    logout: () => dispatch(createLogoutAction()),
    openAegisubAudioVideoTool: () => dispatch(createModalOpenAction(SimpleModalId.AegisubAudioToVideoTranslator)),
  };
}

export default connect(baseMapStateToProps, mapDispatchToProps)(TopMenu);
